export default __webpack_public_path__ + "static/media/default.6fccdfb11ced5f645afed9e1e859fbb4.png";